// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"bb4a75d6","62":"dbc063e2","144":"f0808336","184":"11c27029","268":"2284ceb6","427":"ffd2def9","809":"dbec0f0c","881":"04d380e2","908":"de558679"}[chunkId] + ".chunk.js";
};